/*
 * decaffeinate suggestions:
 * DS002: Fix invalid constructor
 * DS102: Remove unnecessary code created because of implicit returns
 * DS205: Consider reworking code to avoid use of IIFEs
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
import React from 'react';
import * as ReactDnD from 'react-dnd';
import PropTypes from 'prop-types';

import * as Constants from '../constants';
import { FormHeader } from '../../react/form_header.jsx';
import { FormInputGroup } from '../../react/form_input_group.jsx';
import * as Actions from '../store/actions';
import { FormRow } from '../../react/form_row.jsx';
import { TicketGroupForm } from './ticket_group_form.jsx';
import { TicketList } from './ticket_list.jsx';

class TicketGroup extends React.Component {
      static propTypes = {
        header: PropTypes.bool,
        tableHeader: PropTypes.bool,
        ticketGroup: Actions.TicketGroupShape,
        tickets: PropTypes.array,
        onTicketChange: PropTypes.func,
        onTicketDelete: PropTypes.func,
        onToggleTicketEditor: PropTypes.func,
        onGroupChange: PropTypes.func,
        onGroupDelete: PropTypes.func,
        onToggleTicketGroupEditor: PropTypes.func,
        canMove: PropTypes.bool,
        canRemove: PropTypes.bool,
        openedEditors: PropTypes.array,
        showGroupEditor: PropTypes.bool,
        haveNoTickets: PropTypes.bool
      };

      static defaultProps = {
        tickets: [],
        ticketGroup: {
          id: null,
          name: 'Default'
        },
        header: true,
        canMove: true,
        canRemove: true,
        settings: {},
        openedEditors: [],
        showGroupEditor: false,
        haveNoTickets: false
      };

      constructor(...args) {
        super(...args);
        this.groupChanged = this.groupChanged.bind(this);
        this.deleteTicket = this.deleteTicket.bind(this);
        this.toggleEditForm = this.toggleEditForm.bind(this);
        this.closeEditForm = this.closeEditForm.bind(this);
      }

      groupChanged(field_name, field_value, event) {
        return (typeof this.props.onGroupChange === 'function' ? this.props.onGroupChange(this.props.ticketGroup.id, field_name, field_value, event) : undefined);
      }

      deleteTicket(event) {
        event.preventDefault();
        return (typeof this.props.onGroupDelete === 'function' ? this.props.onGroupDelete(this.props.ticketGroup.id, event) : undefined);
      }

      toggleEditForm(event) {
        event.preventDefault();
        return (typeof this.props.onToggleTicketGroupEditor === 'function' ? this.props.onToggleTicketGroupEditor(this.props.ticketGroup.id) : undefined);
      }

      closeEditForm(event) {
        event.preventDefault();
        return (typeof this.props.onToggleTicketGroupEditor === 'function' ? this.props.onToggleTicketGroupEditor(this.props.ticketGroup.id, false) : undefined);
      }

      render() {
        const header = (() => {
          if (this.props.header) {
          const group_form = this.props.showGroupEditor ?
            <TicketGroupForm ticketGroup={this.props.ticketGroup}
                              onChange={this.groupChanged}
                              onClose={this.closeEditForm}/> : undefined;

          return <tbody>
            <tr className="ticket-group-header-row">
              <td width="89%" colSpan="4" className="ticket-group-header">
                {this.props.connectDragSource(<i className="fa fa-bars drag-handle" aria-hidden="true"></i>)}
                {this.props.ticketGroup.name}
              </td>
              <td width="11%">
                <div className="text-right action_icon_button">
                  <a href="#"
                     onClick={this.toggleEditForm}
                     title="Edit Ticket"
                     className="edit_button"><i className="localist-icon-edit-small"></i></a>
                  <a href="#"
                     onClick={this.deleteTicket}
                     title="Remove Ticket"
                     className="deletex_button"><i className="localist-icon-trash-small"></i></a>
                </div>
              </td>
            </tr>
            {group_form}
          </tbody>;
        }
        })();

        return this.props.connectDropTarget(<div className="ticket-group-wrapper">
            <TicketList header={this.props.tableHeader}
                        groupHeader={header}
                        debug={this.props.debug}
                        tickets={this.props.tickets}
                        haveNoTickets={this.props.haveNoTickets}
                        openedEditors={this.props.openedEditors}
                        settings={this.props.settings}
                        connectGroupDragPreview={this.props.connectDragPreview}
                        onToggleTicketEditor={this.props.onToggleTicketEditor}
                        onAddTicketClass={this.props.onAddTicketClass}
                        onChange={this.props.onTicketChange}
                        onDelete={this.props.onTicketDelete}
                        onDragStart={this.props.onTicketDragStart}
                        onDragFinish={this.props.onTicketDragFinish}
                        onDragCancel={this.props.onTicketDragCancel}
                        onDragUpdate={this.props.onTicketDragUpdate} />
        </div>
        );
      }
}

const dragSpec = {
      beginDrag(props, monitor, component) {
        const item = { id: props.ticketGroup.id };
        if (typeof props.onGroupDragStart === 'function') {
          props.onGroupDragStart(item);
        }
        return item;
      },

      endDrag(props, monitor, component) {
        if (monitor.didDrop()) {
          const result = monitor.getDropResult();
          return (typeof props.onGroupDragFinish === 'function' ? props.onGroupDragFinish({item: {id: props.ticketGroup.id}, target_position: result.position}) : undefined);
        } 
          return (typeof props.onGroupDragCancel === 'function' ? props.onGroupDragCancel({id: props.ticketGroup.id}) : undefined);
        
      },

      canDrag(props, monitor) {
        return props.canMove !== false;
      }
    };

    const dragCollect = (connect, monitor) => ({
      isDragging: monitor.isDragging(),
      connectDragSource: connect.dragSource(),
      connectDragPreview: connect.dragPreview()
    });

    // Drop target configuration
    const dropSpec = {
      drop(props, monitor, component) {
        switch (monitor.getItemType()) {
          case Constants.DRAG_TYPE_TICKET_GROUP:
            return {position: props.ticketGroup ? props.ticketGroup.position : 0};
          case Constants.DRAG_TYPE_TICKET_CLASS:
            return {position: 'top', ticket_group_id: (props.ticketGroup != null ? props.ticketGroup.id : undefined)};
        }
      },


      hover(props, monitor, component) {
        let item;
        switch (monitor.getItemType()) {
          case Constants.DRAG_TYPE_TICKET_GROUP:
            if (monitor.canDrop() && monitor.isOver()) {
              item = monitor.getItem();
              if (item.id !== (props.ticketGroup != null ? props.ticketGroup.id : undefined)) {
                return (typeof props.onGroupDragUpdate === 'function' ? props.onGroupDragUpdate(item, props.ticketGroup ? props.ticketGroup.position : 0) : undefined);
              }
            }
            break;
          case Constants.DRAG_TYPE_TICKET_CLASS:
            if (monitor.canDrop() && monitor.isOver({shallow: true})) {
              item = monitor.getItem();
              return (typeof props.onTicketDragUpdate === 'function' ? props.onTicketDragUpdate(item, 'top', props.ticketGroup != null ? props.ticketGroup.id : undefined) : undefined);
            }
            break;
        }
      }
    };

    const dropCollect = (connect, monitor) => ({
      hovered: monitor.isOver(),
      connectDropTarget: connect.dropTarget()
    });

const TicketGroupWithDrag = ReactDnD.DragSource(Constants.DRAG_TYPE_TICKET_GROUP, dragSpec, dragCollect)(TicketGroup);
export const TicketGroupContainer = ReactDnD.DropTarget([Constants.DRAG_TYPE_TICKET_GROUP, Constants.DRAG_TYPE_TICKET_CLASS], dropSpec, dropCollect)(TicketGroupWithDrag);

